function sortable() {
  //ставим фиксированную высоту, чтобы избежать скачков
  $(window).on('load resize', function(){
    let height = $(".js-sortable").outerHeight() + 'px';
    $(".js-sortable").css("height", height);
  });

  $(".js-sortable")
      .sortable({
          axis: "y",
          cursor: "move"
      })
      .disableSelection();

  $(".js-sortable-multiple")
      .sortable({
        cursor: "move",
        connectWith: ".js-draggable-multiple"
      })
      .disableSelection();

  $(".js-sortable-images")
      .sortable({
        tolerance : "pointer",
        cursor: "move"
      })
      .disableSelection();
}
